module.exports = __webpack_public_path__ + "media/claim/assets/images/trustpilot/45stars-55dde674738e1df52f733b5322ea5c25.png";